<template>
    <div class="design_store select_product">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item">
                            <a href="#">Team Store</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Custom Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="wizard d-flex justify-content-center align-items-center"
                        >
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Basic Information</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Select Product</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">3</div>
                                <h5 class="mb-0">Design</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">4</div>
                                <h5 class="mb-0">Shipping</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">5</div>
                                <h5 class="mb-0">Publish</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="design_store">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 d-md-inline-flex align-items-center">
                        <h1 class="heading1 m-0">Design</h1>
                        <div class="ml-auto">
                            <a
                                href="#"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue ml-auto px_12 py_10"
                                data-toggle="modal"
                                data-path=""
                                data-target="#more_product_modal"
                            >
                                DESIGN MORE PRODUCT</a
                            >
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mt_34">
                        <img
                            src="/maincss/images/design_tool_image.png"
                            alt=" "
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="buttons mt_100 ml-auto text-right">
                            <a
                                href="/team/design-team-store"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52"
                                >Save</a
                            >
                            <a
                                href="/team/select-product"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52 ml_52 mr_36"
                                >BACK</a
                            >
                            <a
                                href="/team/shipping"
                                class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                                >Next</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- More product Modal Start -->

        <div
            class="modal more_product_popup fade"
            id="more_product_modal"
            tabindex="-1"
            aria-labelledby="more_product_modal"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>

                        <section class="select_products">
                            <div class="container">
                                <div class="row team_store">
                                    <div class="col-md-12 search_for_product">
                                        <div
                                            class="heading_with_search d-md-flex align-items-center"
                                        >
                                            <div>
                                                <h1 class="heading1 m-0">
                                                    Select Any Product
                                                </h1>
                                            </div>
                                            <div
                                                class="serach d-flex ml-auto position-relative"
                                            >
                                                <label>Search</label>
                                                <div class="search_field pl_24">
                                                    <input
                                                        type="text"
                                                        placeholder="e.g. T-Shirt,"
                                                        class="form-control"
                                                    />
                                                    <a
                                                        href="#"
                                                        class="search_icon"
                                                        ><img
                                                            src="/maincss/images/side_bar_serach.svg"
                                                            alt=" "
                                                    /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt_30">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div
                                                class="col-md-6 col-lg-4 col-xl-4"
                                            >
                                                <div class="product">
                                                    <div
                                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                    >
                                                        <img
                                                            src="/maincss/images/select_product1.png"
                                                            alt=" "
                                                            class="img-fluid product_image_main"
                                                        />
                                                        <span
                                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                            >-86%</span
                                                        >

                                                        <div
                                                            class="form-check popup_radio_btn"
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault1"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="flexRadioDefault1"
                                                            >
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="product_content mt_24"
                                                    >
                                                        <h5 class="heading5">
                                                            2 Mesh Long Sleeve
                                                            Tee
                                                        </h5>
                                                        <div
                                                            class="form-check pl-0 py_6"
                                                        >
                                                            <label
                                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                                >Mandatory Item
                                                                <input
                                                                    type="checkbox"
                                                                    checked="checked" /><span
                                                                    class="checkmark"
                                                                ></span
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6 col-lg-4 col-xl-4"
                                            >
                                                <div class="product">
                                                    <div
                                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative checked_active"
                                                    >
                                                        <img
                                                            src="/maincss/images/select_product2.png"
                                                            alt=" "
                                                            class="img-fluid product_image_main"
                                                        />
                                                        <span
                                                            class="offer-badge px_20 py_2 bg_primary_red font_size_16 text_white"
                                                            >-86%</span
                                                        >
                                                        <div
                                                            class="form-check popup_radio_btn"
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault2"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="flexRadioDefault2"
                                                            >
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="product_content mt_24"
                                                    >
                                                        <h5 class="heading5">
                                                            Classic C-Handle
                                                            11oz Mugs
                                                        </h5>
                                                        <div
                                                            class="form-check pl-0 py_6"
                                                        >
                                                            <label
                                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                                >Mandatory Item
                                                                <input
                                                                    type="checkbox" /><span
                                                                    class="checkmark"
                                                                ></span
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6 col-lg-4 col-xl-4"
                                            >
                                                <div class="product">
                                                    <div
                                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative checked_active"
                                                    >
                                                        <img
                                                            src="/maincss/images/select_product3.png"
                                                            alt=" "
                                                            class="img-fluid product_image_main"
                                                        />
                                                        <span
                                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                            >-86%</span
                                                        >
                                                        <div
                                                            class="form-check popup_radio_btn"
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault3"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="flexRadioDefault3"
                                                            >
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="product_content mt_24"
                                                    >
                                                        <h5 class="heading5">
                                                            Sweatshirts
                                                        </h5>
                                                        <div
                                                            class="form-check pl-0 py_6"
                                                        >
                                                            <label
                                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                                >Mandatory Item
                                                                <input
                                                                    type="checkbox" /><span
                                                                    class="checkmark"
                                                                ></span
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6 col-lg-4 col-xl-4"
                                            >
                                                <div class="product">
                                                    <div
                                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                    >
                                                        <img
                                                            src="/maincss/images/select_product4.png"
                                                            alt=" "
                                                            class="img-fluid product_image_main"
                                                        />
                                                        <span
                                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                            >-86%</span
                                                        >
                                                        <div
                                                            class="form-check popup_radio_btn"
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault4"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="flexRadioDefault4"
                                                            >
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="product_content mt_24"
                                                    >
                                                        <h5 class="heading5">
                                                            Custom Classic Soft
                                                            Crown Caps
                                                        </h5>
                                                        <div
                                                            class="form-check pl-0 py_6"
                                                        >
                                                            <label
                                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                                >Mandatory Item
                                                                <input
                                                                    type="checkbox" /><span
                                                                    class="checkmark"
                                                                ></span
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6 col-lg-4 col-xl-4"
                                            >
                                                <div class="product">
                                                    <div
                                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative checked_active"
                                                    >
                                                        <img
                                                            src="/maincss/images/select_product5.png"
                                                            alt=" "
                                                            class="img-fluid product_image_main"
                                                        />
                                                        <span
                                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                            >-86%</span
                                                        >
                                                        <div
                                                            class="form-check popup_radio_btn"
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault5"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="flexRadioDefault5"
                                                            >
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="product_content mt_24"
                                                    >
                                                        <h5 class="heading5">
                                                            2 Mesh Long Sleeve
                                                            Tee
                                                        </h5>
                                                        <div
                                                            class="form-check pl-0 py_6"
                                                        >
                                                            <label
                                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                                >Mandatory Item
                                                                <input
                                                                    type="checkbox" /><span
                                                                    class="checkmark"
                                                                ></span
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6 col-lg-4 col-xl-4"
                                            >
                                                <div class="product">
                                                    <div
                                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative checked_active"
                                                    >
                                                        <img
                                                            src="/maincss/images/select_product3.png"
                                                            alt=" "
                                                            class="img-fluid product_image_main"
                                                        />
                                                        <span
                                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                            >-86%</span
                                                        >
                                                        <div
                                                            class="form-check popup_radio_btn"
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault6"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="flexRadioDefault6"
                                                            >
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="product_content mt_24"
                                                    >
                                                        <h5 class="heading5">
                                                            Sweatshirts
                                                        </h5>
                                                        <div
                                                            class="form-check pl-0 py_6"
                                                        >
                                                            <label
                                                                class="checkbox_custom d-inline-block font_size_18 proximaNova_semibold"
                                                                >Mandatory Item
                                                                <input
                                                                    type="checkbox" /><span
                                                                    class="checkmark"
                                                                ></span
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div
                                                    class="buttons ml-auto text-center"
                                                >
                                                    <a
                                                        href="#"
                                                        class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                                                        >Select</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>

        <!-- More product Modal End -->
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Design",
    /* eslint-enable */
    components: {},
    mounted() {
        document.body.classList.add("");
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
